<template>
  <div class="m-10">
    <div>
      <ul>
        <li>
          <p class="text-xl">1. 弊社のサービスをどこでお知りになりましたか？</p>
          <PieChart
            ref="pieRef"
            :chart-data="oneQuestion"
            :options="options" />
          <div class="h-72 overflow-y-auto my-6 mx-10 scrollbar scrollbar-thumb-rounded scrollbar-thumb-black">
            <table class="table-auto w-full">
              <tr class="sticky -top-0.5 bg-gray-300">
                <th class="text-center border px-4 py-2 w-16">No.</th>
                <td class="border px-4 py-2">自由記入欄</td>
              </tr>
              <tr
                v-for="(text, i) in oneTextDatas"
                :key="i">
                <th class="bg-gray-100 text-center border px-4 py-2">{{ i + 1 }}</th>
                <td class="border px-4 py-2">{{ text.q1text }}</td>
              </tr>
            </table>
          </div>
        </li>
        <li>
          <p class="text-xl my-12">2. 弊社サービスに対する満足度を教えてください。</p>
          <PieChart
            ref="pieRef"
            :chart-data="twoQuestion"
            :options="options" />
        </li>
        <li>
          <p class="text-xl my-12">3. 模試の事前登録の値段(2,800円)について感想をお聞かせください。</p>
          <PieChart
            ref="pieRef"
            :chart-data="threeQuestion"
            :options="options" />
        </li>
        <li>
          <p class="text-xl my-12">4. 模試の通常の値段(4,000円)について感想をお聞かせください。</p>
          <PieChart
            ref="pieRef"
            :chart-data="fourQuestion"
            :options="options" />
        </li>
        <li>
          <p class="text-xl my-12">5. 1年間で何回の模擬試験を希望しますか？</p>
          <PieChart
            ref="pieRef"
            :chart-data="fiveQuestion"
            :options="options" />
        </li>
        <li>
          <p class="text-xl my-12">6. 動物看護師としてのキャリアを充実させるために今後どのようなサービスを期待しますか？</p>
          <PieChart
            ref="pieRef"
            :chart-data="sixQuestion"
            :options="options" />
          <div class="h-72 overflow-y-auto mt-6 mx-10 scrollbar scrollbar-thumb-rounded scrollbar-thumb-black">
            <table class="table-auto w-full">
              <tr class="sticky -top-0.5 bg-gray-300">
                <th class="text-center border px-4 py-2">No.</th>
                <td class="border px-4 py-2">自由記入欄</td>
                <td class="border px-4 py-2">記入日</td>
              </tr>
              <tr
                v-for="(text, i) in sixTextDatas"
                :key="i">
                <th class="bg-gray-100 text-center border px-4 py-2">{{ i + 1 }}</th>
                <td class="border px-4 py-2">{{ text.q6text }}</td>
                <td class="border px-4 py-2">{{ moment(`${text.created_at}`).format('YYYY/MM/DD') }}</td>
              </tr>
            </table>
          </div>
        </li>
        <li>
          <p class="text-xl my-12">7. 弊社サービスに対するご意見・ご要望がありましたら、ご自由にお書きください。</p>
          <div class="h-72 overflow-y-auto mt-6 mx-10 scrollbar scrollbar-thumb-rounded scrollbar-thumb-black">
            <table class="table-auto w-full">
              <tr class="sticky -top-0.5 bg-gray-300">
                <th class="text-center border px-4 py-2">No.</th>
                <td class="border px-4 py-2">自由記入欄</td>
                <td class="border px-4 py-2">記入日</td>
              </tr>
              <tr
                v-for="(text, i) in sevenTextDatas"
                :key="i">
                <th class="bg-gray-100 text-center border px-4 py-2">{{ i + 1 }}</th>
                <td class="border px-4 py-2">{{ text.q7text }}</td>
                <td class="border px-4 py-2">{{ moment(`${text.created_at}`).format('YYYY/MM/DD') }}</td>
              </tr>
            </table>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import {
  defineProps,
  ref,
  computed,
} from 'vue'
import { Chart, registerables } from 'chart.js'
import { LineChart, BarChart, PieChart } from 'vue-chart-3'
import moment from 'moment'

const props = defineProps({
  oneQuestionDatas: {
    type: Array,
    default: () => [],
  },
  oneTextDatas: {
    type: Array,
    default: () => [],
  },
  twoQuestionDatas: {
    type: Array,
    default: () => [],
  },
  threeQuestionDatas: {
    type: Array,
    default: () => [],
  },
  fourQuestionDatas: {
    type: Array,
    default: () => [],
  },
  fiveQuestionDatas: {
    type: Array,
    default: () => [],
  },
  sixQuestionDatas: {
    type: Array,
    default: () => [],
  },
  sixTextDatas: {
    type: Array,
    default: () => [],
  },
  sevenTextDatas: {
    type: Array,
    default: () => [],
  },
})
const options = ref({
  responsive: true,
  plugins: {
    legend: {
      position: 'left',
      labels: {
        font: {
          size: 16,
        },
      },
    },
  },
})
const pieRef = ref()

const oneChartData = ref(new Array(5).fill(0))
const assignmentOneData = () => {
  for (let i = 0; i < props.oneQuestionDatas.length; i += 1) {
    for (let ii = 1; ii <= oneChartData.value.length; ii += 1) {
      if (ii === props.oneQuestionDatas[i].questionNum) {
        oneChartData.value[ii - 1] = props.oneQuestionDatas[i].count
      }
    }
  }
}
assignmentOneData()
const oneQuestion = computed(() => ({
  labels: ['Instagram', 'チラシ', 'インターネット検索', '家族・友人・知人からの口コミ', 'その他'],
  datasets: [
    {
      data: oneChartData.value,
      backgroundColor: [
        '#C0392B',
        '#E74C3C',
        '#9B59B6',
        '#2980B9',
        '#3498DB',
      ],
      hoverOffset: 4,
    },
  ],
}))
const twoChartData = ref(new Array(5).fill(0))
const assignmentTwoData = () => {
  for (let i = 0; i < props.twoQuestionDatas.length; i += 1) {
    for (let ii = 1; ii <= twoChartData.value.length; ii += 1) {
      if (ii === props.twoQuestionDatas[i].questionNum) {
        twoChartData.value[ii - 1] = props.twoQuestionDatas[i].count
      }
    }
  }
}
assignmentTwoData()
const twoQuestion = computed(() => ({
  labels: ['満足', 'やや満足', 'どちらとも言えない', 'やや不満', ' 不満'],
  datasets: [
    {
      data: twoChartData.value,
      backgroundColor: [
        '#C0392B',
        '#E74C3C',
        '#9B59B6',
        '#2980B9',
        '#3498DB',
      ],
      hoverOffset: 4,
    },
  ],
}))

const threeChartData = ref(new Array(5).fill(0))
const assignmentThreeData = () => {
  for (let i = 0; i < props.threeQuestionDatas.length; i += 1) {
    for (let ii = 1; ii <= threeChartData.value.length; ii += 1) {
      if (ii === props.threeQuestionDatas[i].questionNum) {
        threeChartData.value[ii - 1] = props.threeQuestionDatas[i].count
      }
    }
  }
}
assignmentThreeData()
const threeQuestion = computed(() => ({
  labels: ['高い', 'やや高い', '妥当', 'やや安い', '安い'],
  datasets: [
    {
      data: threeChartData.value,
      backgroundColor: [
        '#C0392B',
        '#E74C3C',
        '#9B59B6',
        '#2980B9',
        '#3498DB',
      ],
      hoverOffset: 4,
    },
  ],
}))

const fourChartData = ref(new Array(5).fill(0))
const assignmentFourData = () => {
  for (let i = 0; i < props.fourQuestionDatas.length; i += 1) {
    for (let ii = 1; ii <= fourChartData.value.length; ii += 1) {
      if (ii === props.fourQuestionDatas[i].questionNum) {
        fourChartData.value[ii - 1] = props.fourQuestionDatas[i].count
      }
    }
  }
}
assignmentFourData()
const fourQuestion = computed(() => ({
  labels: ['高い', 'やや高い', '妥当', 'やや安い', '安い'],
  datasets: [
    {
      data: fourChartData.value,
      backgroundColor: [
        '#C0392B',
        '#E74C3C',
        '#9B59B6',
        '#2980B9',
        '#3498DB',
      ],
      hoverOffset: 4,
    },
  ],
}))

const fiveChartData = ref(new Array(5).fill(0))
const assignmentFiveData = () => {
  for (let i = 0; i < props.fiveQuestionDatas.length; i += 1) {
    for (let ii = 1; ii <= fiveChartData.value.length; ii += 1) {
      if (ii === props.fiveQuestionDatas[i].questionNum) {
        fiveChartData.value[ii - 1] = props.fiveQuestionDatas[i].count
      }
    }
  }
}
assignmentFiveData()
const fiveQuestion = computed(() => ({
  labels: ['1回', '2-3回', '4-5回', '6回以上'],
  datasets: [
    {
      data: fiveChartData.value,
      backgroundColor: [
        '#C0392B',
        '#E74C3C',
        '#9B59B6',
        '#2980B9',
      ],
      hoverOffset: 4,
    },
  ],
}))
const sixChartData = ref(new Array(5).fill(0))
const assignmentSixData = () => {
  for (let i = 0; i < props.sixQuestionDatas.length; i += 1) {
    for (let ii = 1; ii <= sixChartData.value.length; ii += 1) {
      if (ii === props.sixQuestionDatas[i].questionNum) {
        sixChartData.value[ii - 1] = props.sixQuestionDatas[i].count
      }
    }
  }
}
assignmentSixData()
const sixQuestion = computed(() => ({
  labels: ['問題演習モバイルアプリ', 'オンライン個別授業', 'オンライン集団授業', ' 就職・転職支援サービス', 'その他'],
  datasets: [
    {
      data: sixChartData.value,
      backgroundColor: [
        '#C0392B',
        '#E74C3C',
        '#9B59B6',
        '#2980B9',
        '#3498DB',
      ],
      hoverOffset: 4,
    },
  ],
}))
</script>
